import React, { useContext, useEffect } from 'react';
import {
  Outlet, useLocation, useNavigate
} from 'react-router-dom';

import { NewWillContext } from './new-will-provider';

interface NewWillGuardProps {
  initLoad: boolean;
  setInitLoad: (value: boolean) => void;
}

export function NewWillGuard({ initLoad, setInitLoad }: NewWillGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { will } = useContext(NewWillContext);

  console.log('INIT LOAD', initLoad);

  useEffect(() => {
    console.log('NewWillGuard effect', will);
    setInitLoad(false);

    if (will && will.status === 'complete') {
      console.log('existing completed will', will);
      return navigate({
        pathname: `/people/self/life-documents/will/${will.id}`,
        search: location.search
      }, { replace: true });
    }

    if (will && initLoad) {
      console.log('existing will', will);
      return navigate({
        pathname: '/people/self/life-documents/will/new/continue',
        search: location.search
      }, { replace: true });
    }

    if (will) {
      console.log('existing draft will', will);
      return;
    }

    return navigate({
      pathname: '/people/self/life-documents/will/new',
      search: location.search
    }, { replace: true });
  }, [ initLoad, location.search, navigate, setInitLoad, will ]);

  return <Outlet />; // Render the nested routes
}
